module.exports = __webpack_public_path__ + "img/lsp.5b4856ab.png";